import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@/components/ui/dialog';

type ImagePreviewDialogProps = {
  imageUrl: string | null;
  onClose: () => void;
  title?: string;
};

export function ImagePreviewDialog({ imageUrl, onClose }: ImagePreviewDialogProps) {
  return (
    <Dialog open={!!imageUrl} onOpenChange={() => onClose()}>
      {/* Remove padding and close button default styling for an immersive view */}
      <DialogContent className="max-w-5xl p-0 border-none bg-transparent shadow-none">
        <DialogTitle className="sr-only">Image Preview</DialogTitle>
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Full size preview"
            className="w-full h-auto rounded-md object-contain max-h-[90vh]"
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
